import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { DatePipe } from '@angular/common';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-mi-inventory-details',
  templateUrl: './mi-inventory-details.component.html',
  styleUrls: ['./mi-inventory-details.component.scss'],
  providers: [DatePipe],
})
export class MiInventoryDetailsComponent implements OnInit {
  submitInventoryForm: FormGroup;
  submitPurchaseForm: FormGroup;
  isSubmitted: boolean = false;
  categoryList: any;
  componentList: any;
  sizeIdList: any;
  itemTypeList: any = [];
  pogramNameList: any;
  datePurchase: any;
  uploadedFiles: any[] = [];
  hideData = true;
  public vendorRegId: any;
  public program: any;
  public selectedProgram: any = [];
  public vendor: any;
  public selectedVendor: any = [];
  public category: any;
  public selectedCategory: any = [];
  public cml: any;
  public selectedCML: any = [];
  public programId: any;
  public vendorId: any;
  public categoryId: any;
  public cmlId: any;
  public selectedDate: Date;
  public filteredVendor: any[];
  componentId: any;
  sizeId: any;
  userId: any;
  public ipAddress: any = '000.000.000';
  selectedItemType: any;
  uploadFileUrl: any;
  fileType: any;

  miInventoryData: any;
  mobileMiInventoryData: any;

  public currentDate: any;
  public minDate: any;

  public displayUpdateInventoryDialog: boolean = false;

  public rowDateToUpdate: any;

  constructor(
    private fb: FormBuilder,
    private vendorDashboardService: VendorDashboardService,
    private loader: AppLoaderService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private ipService: IpAddressService,
    private _personalDetalSer: FarmersDetailsService,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService,
    private cryptoJsService: CryptoJsService,
  ) {}

  ngOnInit(): void {
    this.activityRecordService.activityRecord(
      this.userId,
      'MI Component Inventory Details',
      '',
      new Date(),
      'Success'
    );
    this.init();
    this.currentDate = new Date();
    this.minDate = new Date("04/01/2022");
  }

  init() {
    this.submitInventoryForm = this.fb.group({
      programId: ['', Validators.required],
      categoryId: ['', Validators.required],
      componentId: ['', Validators.required],
      sizeId: ['', Validators.required],
      qauntity: ['', Validators.required],
      consumedQuantity: ['', Validators.required],
      batchNo: ['', Validators.required],
      lotNo: ['', Validators.required],
      itemType: ['', Validators.required],
      datePurchase: ['', Validators.required],
      purchaseInvoiceNo: ['', Validators.required],
      billCopyPath: [''],
    });
    
    this.getIP();
    this.loadData();
    this.itemTypeList = [
      {
        id: 1,
        item: 'Manufacture',
      },
      {
        id: 2,
        item: 'Purchase',
      },
    ];
    this.selectedItemType = 'Manufacture';
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  loadData() {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.vendorRegId = JSON.stringify(token?.officeCode);
    this.getProgramList();
    // console.log('this.vendorRegId', this.vendorRegId)
    this.getInventoryPurchaseDetail(this.vendorRegId);
  }

  getInventoryPurchaseDetail(vendorRegId) {
    this.loader.start();
    this.vendorDashboardService
      .getInventoryPurchaseDetail(vendorRegId)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          this.miInventoryData = resp;
          this.miInventoryData = this.miInventoryData.map((val) => ({
            ...val,
            invoiceBillDateForSorting: new Date(val?.InvoiceBillDate),
          }));

          this.mobileMiInventoryData = this.miInventoryData;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Inventory Details not loaded.',
          });
        },
      });
  }

  getProgramList() {
    this.loader.start();
    this.vendorDashboardService
      .getComponentMaster()
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.loader.close();
          this.pogramNameList = files;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Program Details not loaded.',
          });
        },
      });
  }

  getCategoriesList() {
    const reqBody = {
      VendorRegId: this.vendorRegId,
      ProgramId: this.programId,
    };
    this.loader.start();
    this.vendorDashboardService
      .getCategory(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.categoryList = res.$values;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.category = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getComponentsList() {
    const reqBody = {
      VendorRegId: this.vendorRegId,
      ProgramId: this.programId,
      CategoryId: this.categoryId,
    };
    this.loader.start();
    this.vendorDashboardService
      .getComponent(reqBody)
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.loader.close();
          this.componentList = files.$values;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Category Details not loaded.',
          });
        },
      });
  }

  getSizePriceList() {
    const reqBody = {
      VendorRegId: this.vendorRegId,
      ProgramId: this.programId,
      CategoryId: this.categoryId,
      ComponentId: this.componentId,
    };
    this.loader.start();
    this.vendorDashboardService
      .getSizeAndPrice(reqBody)
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.loader.close();
          this.sizeIdList = files.$values;
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Size Details not loaded.',
          });
        },
      });
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    if (file.name.includes('.pdf')) {
      this.fileType = 'PDF';
    } else {
      this.fileType = 'IMAGE';
    }
    let data = new FormData();
    data.append('file', file);

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let phNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';

    this._personalDetalSer
      .uploadFile(data, phNo, formcontrol)
      .subscribe((resp: any) => {
        if (resp.data) {
          this.uploadFileUrl = resp.data;
          this.submitInventoryForm.patchValue({ [formcontrol]: resp.data });
        }
        if (resp.statusCode == 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }
      });
    uploadElement.clear();
  }

  getChangeProgram(event) {
    this.programId = event.value;
    this.categoryId = '';
    this.componentId = '';
    this.sizeId = '';
    this.componentList = [];
    this.sizeIdList = [];
    this.getCategoriesList();
  }

  getCategoryChange(event) {
    this.categoryId = event.value;
    this.componentId = '';
    this.sizeId = '';
    this.sizeIdList = [];
    this.getComponentsList();
  }

  getComponentChange(event) {
    this.componentId = event.value;
    this.sizeId = '';
    this.getSizePriceList();
  }

  getSizeIdChange(event) {
    this.sizeId = event.value;
  }

  getItemTypeChange(event) {
    this.selectedItemType = event.value;
    if (event.value === 'Purchase') {
      this.hideData = false;
      // this.submitInventoryForm.controls['billNo'].setValidators(
      //   Validators.required
      // );
      // this.submitInventoryForm.controls['gstCertificatePath'].setValidators(Validators.required);
      this.submitInventoryForm.controls['billCopyPath'].setValidators(Validators.required);
      this.submitInventoryForm.controls['billCopyPath'].updateValueAndValidity();
      this.submitInventoryForm.controls['billCopyPath'].setValue(null);
    } else {
      this.hideData = true;
      this.submitInventoryForm.controls['billCopyPath'].clearValidators();
      this.submitInventoryForm.controls['billCopyPath'].updateValueAndValidity();
      // this.submitInventoryForm.controls['billNo'].clearValidators();
      // this.submitInventoryForm.controls['gstCertificatePath'].clearValidators();
    }
  }

  get f() {
    return this.submitInventoryForm.controls;
  }

  submitInventoryDetails() {
    this.isSubmitted = true;
    // if (!this.submitInventoryForm.get('gstCertificatePath').value) {
    //   this.submitInventoryForm.controls['gstCertificatePath'].setErrors({ 'required': true });
    // } else {
    //   this.submitInventoryForm.controls['gstCertificatePath'].setErrors(null)
    // }
    if (this.hideData) {
      this.f.billCopyPath.setValue('');
      // this.f.purchaseInvoiceNo.setValue('');
    }
    let values = this.submitInventoryForm.value;

    if (this.submitInventoryForm.valid) {
      if (Number(values.qauntity) < Number(values.consumedQuantity)) {
        this.messageService.add({
          severity: 'info',
          summary: 'Validation Error',
          detail:
            'Consumed Quantity must be less than or equal to the Quantity',
        });
        return;
      }
      this.isSubmitted = false;
      let reqBoady = {
        programId: Number(values.programId),
        categoryID: Number(values.categoryId),
        componentID: Number(values.componentId),
        sizeID: Number(values.sizeId),
        quantity: Number(values.qauntity),
        consumedQuantity: Number(values.consumedQuantity),
        lotNo: values.lotNo,
        batchNO: values.batchNo,
        itemType: values.itemType,
        billCopy: values.billCopyPath,
        purchaseInvoiceNo: values.purchaseInvoiceNo,
        invoiceBillDate: values.datePurchase
          ? this.datePipe.transform(new Date(values.datePurchase), 'yyyy-MM-dd')
          : values.datePurchase,
        userID: this.vendorRegId,
        network_Id: this.ipAddress,
        terminal_Id: this.ipAddress,
      };

      this.loader.start();
      this.vendorDashboardService
        .insertVendorInventoryDetail(reqBoady)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();
            this.activityRecordService.activityRecord(
              this.userId,
              'Add MI Component Inventory Details',
              '',
              new Date(),
              data,
              reqBoady
            );
            if (data == 'Record saved Successfully') {
              this.messageService.add({
                severity: 'success',
                summary: 'Status',
                detail: data,
              });
              this.isSubmitted = false;
              this.init();
            } else {
              this.messageService.add({
                severity: 'info',
                summary: 'Status',
                detail: data,
              });
            }
          },
          error: (err) => {
            this.loader.close();
            this.activityRecordService.activityRecord(
              this.userId,
              'Add MI Component Inventory Details',
              '',
              new Date(),
              err, 
              reqBoady
            );
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data Error! Estimation Not Updated',
            });
          },
        });
    }
  }

  mobileSearch(value) {
    this.mobileMiInventoryData = this.miInventoryData.filter((data: any) => {
      if (
        data.ProgramName.toLowerCase().includes(value.toLowerCase()) ||
        data.CategoryName.toLowerCase().includes(value.toLowerCase()) ||
        data.ComponentName.toLowerCase().includes(value.toLowerCase()) ||
        data.SizeName.toLowerCase().includes(value.toLowerCase()) ||
        data.LotNo.toLowerCase().includes(value.toLowerCase()) ||
        data.BatchNO.toLowerCase().includes(value.toLowerCase()) ||
        data.ItemType.toLowerCase().includes(value.toLowerCase()) ||
        data.PurchaseInvoiceNo.toLowerCase().includes(value.toLowerCase()) ||
        data.InvoiceBillDate.toLowerCase().includes(value.toLowerCase())
      ) {
        return data;
      }
    });
  }

  updateInventory(val) {
    if (val?.ItemType == 'Purchase') {
      this.hideData = false;
      this.submitInventoryForm.controls['billCopyPath'].setValidators(
        Validators.required
      );
    } else {
      this.hideData = true;
    }

    this.rowDateToUpdate = val;
    this.submitInventoryForm.setValue({
      programId: val?.ProgramName,
      categoryId: val?.CategoryName,
      componentId: val?.ComponentName,
      sizeId: val?.SizeName,
      qauntity: val?.Quantity,
      consumedQuantity: val?.ConsumedQuantity,
      batchNo: val?.BatchNO,
      lotNo: val?.LotNo,
      itemType: val?.ItemType,
      datePurchase: val?.invoiceBillDateForSorting,
      purchaseInvoiceNo: val?.PurchaseInvoiceNo,
      billCopyPath: val?.BillCopy,
    });
    this.displayUpdateInventoryDialog = true;
  }

  deleteInventory(val) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this Inventory?',
      accept: () => {
        let reqBody = {
          autoId: val.AutoId,
          userID: val.UserID,
          network_Id: this.ipAddress,
          terminal_Id: this.ipAddress,
        };
        this.vendorDashboardService
          .deleteInventoryPurchaseDetail(reqBody)
          .pipe(first())
          .subscribe({
            next: (resp) => {
              this.loader.close();
              if (resp == 'Record deleted Successfully') {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Info Message',
                  detail: JSON.stringify(resp),
                });
                this.loadData();
              } else {
                this.messageService.add({
                  severity: 'info',
                  summary: 'Info Message',
                  detail: JSON.stringify(resp),
                });
              }
              this.activityRecordService.activityRecord(
                this.userId,
                'Delete MI Component Inventory Details',
                '',
                new Date(),
                resp,
                reqBody
              );
            },
            error: (err) => {
              this.loader.close();
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Data error! Data not deleted.',
              });
              this.activityRecordService.activityRecord(
                this.userId,
                'Delete MI Component Inventory Details',
                '',
                new Date(),
                err,
                reqBody
              );
            },
          });
      },
    });
  }

  onCloseDialog() {
    this.displayUpdateInventoryDialog = false;
    this.submitInventoryForm.reset();
    this.isSubmitted = false;
    this.rowDateToUpdate = null;
  }

  updateInventoryDetails() {
    // console.log(this.submitInventoryForm.value);
    this.isSubmitted = true;
    if (this.submitInventoryForm.invalid) {
      return;
    } else {
      // console.log('submit');
      let val = this.submitInventoryForm.value;

      if (Number(val.qauntity) < Number(val.consumedQuantity)) {
        this.messageService.add({
          severity: 'info',
          summary: 'Validation Error',
          detail:
            'Consumed Quantity must be less than or equal to the Quantity',
        });
        return;
      }

      let reqBody = {
        autoId: this.rowDateToUpdate.AutoId,
        programId: this.rowDateToUpdate.ProgramId,
        categoryID: this.rowDateToUpdate.CategoryID,
        componentID: this.rowDateToUpdate.ComponentID,
        sizeID: this.rowDateToUpdate.SizeID,
        quantity: Number(val.qauntity),
        consumedQuantity: Number(val.consumedQuantity),
        lotNo: val.lotNo,
        batchNO: val.batchNo,
        billCopy: val.billCopyPath,
        itemType: val.itemType,
        purchaseInvoiceNo: val.purchaseInvoiceNo,
        invoiceBillDate: this.datePipe.transform(
          new Date(val.datePurchase),
          'yyyy-MM-dd'
        ),
        userID: this.rowDateToUpdate.UserID,
        network_Id: this.ipAddress,
        terminal_Id: this.ipAddress,
      };

      this.vendorDashboardService
        .updateInventoryPurchaseDetail(reqBody)
        .pipe(first())
        .subscribe({
          next: (resp) => {
            this.loader.close();
            this.activityRecordService.activityRecord(
              this.userId,
              'Update MI Component Inventory Details',
              '',
              new Date(),
              resp,
              reqBody
            );
            if (resp == 'Record updated Successfully') {
              this.messageService.add({
                severity: 'success',
                summary: 'Success Message',
                detail: resp,
              });
              this.onCloseDialog();
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'info',
                summary: 'Success Message',
                detail: resp,
              });
            }
          },
          error: (err) => {
            this.loader.close();
            this.activityRecordService.activityRecord(
              this.userId,
              'Update MI Component Inventory Details',
              '',
              new Date(),
              err,
              reqBody
            );
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Data not updated.',
            });
          },
        });
    }
  }
}
